import { useState } from 'react';
import { Volume2, VolumeX } from 'lucide-react';
import {
  isSoundEnabled,
  playNotificationSound,
  setSoundEnabled,
} from '@/lib/sound';
import { cn } from '@/lib/utils';

/**
 * Botão no header que liga/desliga som de notificação. Ao ligar, toca um beep
 * de teste pra confirmar pro usuário (e também pra "acordar" o AudioContext,
 * que em muitos navegadores fica suspenso até a primeira interação).
 */
export function SoundToggle() {
  const [enabled, setEnabled] = useState(() => isSoundEnabled());

  const toggle = async () => {
    const next = !enabled;
    setSoundEnabled(next);
    setEnabled(next);
    if (next) await playNotificationSound();
  };

  const Icon = enabled ? Volume2 : VolumeX;

  return (
    <button
      type="button"
      onClick={toggle}
      title={enabled ? 'Som ligado · clique pra silenciar' : 'Som desligado · clique pra ativar'}
      className={cn(
        'inline-flex items-center justify-center rounded-full border p-1.5 transition-colors',
        enabled
          ? 'border-primary/30 bg-primary/10 text-primary hover:bg-primary/15'
          : 'border-border bg-card text-muted-foreground hover:bg-accent',
      )}
      aria-label={enabled ? 'Silenciar' : 'Ativar som'}
    >
      <Icon className="h-4 w-4" />
    </button>
  );
}
